import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  TextField,
  Button,
  Snackbar,
  Alert,
  Autocomplete,
  Slide,
  Stack,
  AppBar,
  Typography,
  Link,
  Breadcrumbs,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  externalgetApi,
  externalImagepostApi,
  externalpostApi,
} from "../../services/external/externalApis";
import {
  COMPANY_API_01,
  COMPANY_API_02,
  COUNTRY_API,
  FILE_API_01,
} from "../../api/ApiModel";
import { useStyles } from "../../assets/styles/Theme";
import Grid from "@mui/material/Grid";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Navbar from "../../components/common/Navbar";
import { IMAGEBASEURL } from "../../api/EndPoints";
const Managecompany = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [companyData, setCompanyData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imageData, setImageData] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const [data2, setData2] = useState("");
  const { COMPCODE } = SYS_USER.USER_PARAM || {};
  const [errors, setErrors] = useState({});
  const [filePath, setFilePath] = useState("");
  const [filename, setFilename] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetching company details with specified parameters
        const result = await externalgetApi(COMPANY_API_01, "get", {
          COMPCODE,
          STS: CON_STATUS_ACTIVE,
        });
        console.log("company data set:", result);
        // Assuming the API returns an array and we want the first item
        if (result) {
          setCompanyData(result[0]);
          console.log("result", result);
        } else {
          setError("No data found");
        }
        setIsLoading(false);
      } catch (err) {
        setError(err.message || "Error fetching data");
      }
    };

    fetchData();
  }, []);



  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (value.length <= 40) {
      setCompanyData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "", // Clear the error message when the limit is not exceeded
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Value cannot exceed 40 letters.",
      }));
    }
  };

  const handlenumInputValidation = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value) && value.length <= 10) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "", // Clear any existing error message
      }));
      handleChange(event); // Update state with the valid input
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Only numbers and floats are allowed. Maximum 10 digits.",
      }));
    }
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validateNumber = (HOTLINE) => /^[0-9]+$/.test(HOTLINE);

  const validateForm = () => {
    if (!companyData.COMPNAME) return "Company Name is required.";
    if (!companyData.COMPADDRESS1) return "Address 1 is required.";
    if (!validateNumber(companyData.HOTLINE))
      return "Please enter a valid Hotline is required.";
    if (!validateEmail(companyData.EMAIL))
      return "Please enter a valid email address.";
    if (!companyData.CONTATCPERSON) return "Contact Person is required.";

    return null; // No validation errors
  };

  const handleClear = () => {
    setCompanyData({
      COMPCODE: "",

      COMPADDRESS1: "",
      COMPADDRESS2: "",
      COMPADDRESS3: "",
      WEBSITE: "",
      HOTLINE: "",
      FAX: "",

      CONTATCPERSON: "",
      COUNTRYCODE: "",
    });
    setErrors({});
  };

  const handleSubmit = async () => {
    const { EMAIL } = companyData;
    // Define required fields based on your form data
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const requiredFields = [
      { name: "COMPNAME", value: companyData.COMPNAME, label: "Company Name" },
      {
        name: "COMPADDRESS1",
        value: companyData.COMPADDRESS1,
        label: "Address 1",
      },
      { name: "HOTLINE", value: companyData.HOTLINE, label: "Hotline" },
      { name: "EMAIL", value: companyData.EMAIL, label: "Email" },
      {
        name: "CONTATCPERSON",
        value: companyData.CONTATCPERSON,
        label: "Contact Person",
      },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );

    if (!validateEmail(EMAIL)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        EMAIL: "Please enter a valid email address.",
      }));
      setSnackbarMessage("Please enter a valid email address.");
      setOpenErrorSnackbar(true);
      return; // Stop further execution if the email is invalid
    }

    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }

    let finalImagePath = imageData ? imageData : companyData.LOGOPATH || null;

    const payload = {
      COMPCODE,
      COMPNAME: companyData.COMPNAME,
      COMPADDRESS1: companyData.COMPADDRESS1,
      COMPADDRESS2: companyData.COMPADDRESS2,
      COMPADDRESS3: companyData.COMPADDRESS3,
      WEBSITE: companyData.WEBSITE,
      HOTLINE: companyData.HOTLINE,
      FAX: companyData.FAX,
      EMAIL: companyData.EMAIL,
      CONTATCPERSON: companyData.CONTATCPERSON,
      COUNTRYCODE: companyData.COUNTRYCODE,
      // LOGOPATH: "http://216.219.84.38:6969/CLOUD_SYSADMIN/CP240000139/2025-01-09/f10935b4-1efb-4965-b7bf-29c4270ba5b6.jpeg",
      logoimage: String(finalImagePath.split(",")[1]) || finalImagePath,
      LOGOPATH: filename,
      locdate: new Date().toISOString(), // ISO format date
      sts: CON_STATUS_ACTIVE,
      dashboardstyle: "",
      // Assuming 'user' is static
    };

    try {
      console.log("Payload for API call:", payload);

      // Simulate API call delay
      await new Promise((resolve) => setTimeout(resolve, 1000)); // 1-second delay

      const responseData = await externalpostApi(COMPANY_API_02, payload);
      console.log("Success:", responseData);

      setSnackbarMessage("Company details submitted successfully!");
      setOpenSnackbar(true);

      // Optionally navigate to another page or reset the form after a short delay
      setTimeout(() => {
        // navigate("/Viewcompany"); // Redirect after successful submission
        window.location.reload();
      }, 1000); // Wait 2 seconds before navigating
    } catch (error) {
      console.error("Error submitting form:", error);
      setSnackbarMessage("Error submitting form: " + error.message); // Error message
      setOpenErrorSnackbar(true); // Open error snackbar
    }
  };

  const goToView = () => {
    navigate("/Viewcompany");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(COUNTRY_API, "get");
        setData2(result); // Update data with API response
      } catch (err) {
        // Handle error
        console.error("Error fetching currencies:", err);
      }
    };

    fetchData();
  }, []);

  const handleEmailValidation = (event) => {
    const { name, value } = event.target;
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    // Update companyData state first
    handleChange(event);

    // Validate the email input
    if (value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Email is required.", // Optional: check for empty input
      }));
    } else if (validateEmail(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error on valid email
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Please enter a valid email address.", // Set error message for invalid email
      }));
    }
  };

  const handleWebsiteValidation = (event) => {
    const { name, value } = event.target;
    const validateWebsite = (website) =>
      /^(https?:\/\/)?([\w\d\-]+\.)+\w{2,}(\/.*)?$/.test(website);

    // Update companyData state first
    handleChange(event);

    // Validate the website input
    if (value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Website is required.", // Optional: check for empty input
      }));
    } else if (validateWebsite(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error on valid website
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Please enter a valid website URL.", // Set error message for invalid website
      }));
    }
  };

  const handleCountryChange = (event, newValue) => {
    handleChange({
      target: {
        name: "COUNTRYCODE",
        value: newValue ? newValue.COUNTRYCODE : "",
      },
    });
  };

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.error("No file selected.");
      return;
    }

    const fileType = file.type;
    if (fileType !== "image/jpeg" && fileType !== "image/png") {
      console.error("Only JPG and PNG files are allowed.");
      return;
    }

    setFilename(file.name); 

    // Preview the selected image
    const reader = new FileReader();
    reader.onload = (e) => setImageData(e.target.result);
    reader.readAsDataURL(file);

    // Prepare the companyData
    const companyData = new FormData();
    companyData.append("file", file);

    try {
      // Construct the API URL with the COMPCODE in the query string
      const apiUrl = `${FILE_API_01}?COMPCODE=${encodeURIComponent(COMPCODE)}`;
      console.log("Sending request to API:", apiUrl);

      // Send the file to the server
      const response = await externalImagepostApi(apiUrl, companyData);

      // Log the complete response for debugging
      console.log("API Response:", response);

      // Safely extract the filePath from the response data
      const { filePath } = response || {};
      if (filePath) {
        // Convert Windows-style path to URL-friendly format
        const formattedPath = filePath.replace(/\\/g, "//");

        // Assuming you need the full URL path, prepend a base URL
        const fullPath = `${IMAGEBASEURL}${formattedPath}`;

        // Set the file path (you can adjust the base URL as necessary)
        setFilePath(fullPath);
        setImageData(fullPath);
        console.log("File uploaded successfully:", fullPath);
      } else {
        console.error(
          "File path not found in the API response:",
          response.data
        );
      }
    } catch (error) {
      console.error("Error uploading file:", error);

      // Handle API response errors
      if (error.response) {
        console.error("API Response Error Data:", error.response.data);
      } else {
        console.error("Network or other error:", error.message);
      }
    }
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Account Management</Link>
                <Link underline="none">Company Profile</Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box
        sx={{
          ...styles.box_container_add,
        }}
      >
        <Box sx={styles.col_title}>
          <Typography variant="title" align="left">
            Company Details
          </Typography>
        </Box>
        <Grid
          container
          sx={{
            background: theme.palette.background.paper,
            mt: 2,
            boxShadow: 1,
          }}
        >
          <Grid
            item
            xs={12}
            md={6}
            sm={12}
            lg={6}
            xl={6}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            {" "}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                gap: "20px", // Space between the image and button
                padding: { xs: "20px", sm: "20px", md: "0" },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* Image Display Box */}
              <Box
                sx={{
                  width: 200,
                  height: 200,
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f9f9f9",
                  flexShrink: 0,
                }}
              >
                {imageData || companyData?.LOGOPATH ? (
                  <img
                    src={imageData || `${companyData.LOGOPATH}`} 
                    alt="Logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      fontSize: 14,
                      color: "#888",
                      textAlign: "center",
                    }}
                  >
                    No Image Selected
                  </Box>
                )}
              </Box>

              {/* Upload Button */}
              <Button
                component="label"
                variant="contained"
                startIcon={<CloudUploadIcon />}
              >
                Upload Image
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleImageChange}
                />
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} sm={12} lg={6} xl={6}>
            <Grid
              container
              spacing={4}
              direction="row"
              sx={{
                ...styles.AI_container_company,
              }}
            >
              <Grid item xs={12} md={6} sm={12} lg={6} xl={6}>
                <TextField
                  id="com_txt1"
                  name="COMPNAME"
                  label="Company Name"
                  size="small"
                  fullWidth
                  variant="standard"
                  autoComplete="off"
                  value={companyData?.COMPNAME || ""}
                  // value={companyData.COMPNAME}
                  onChange={handleChange}
                  error={!!errors.COMPNAME}
                  helperText={errors.COMPNAME}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6} sm={12} lg={6} xl={6}>
                <TextField
                  id="com_txt5"
                  name="WEBSITE"
                  label="Website"
                  fullWidth
                  size="small"
                  variant="standard"
                  autoComplete="off"
                  value={companyData?.WEBSITE || ""}
                  // value={companyData.WEBSITE}
                  onChange={handleWebsiteValidation}
                  error={!!errors.WEBSITE}
                  helperText={errors.WEBSITE}
                />
              </Grid>

              <Grid item xs={12} md={6} sm={12} lg={6} xl={6}>
                <TextField
                  id="com_txt2"
                  name="COMPADDRESS1"
                  label="Address 1"
                  size="small"
                  fullWidth
                  variant="standard"
                  autoComplete="off"
                  value={companyData?.COMPADDRESS1 || ""}
                  // value={companyData.COMPADDRESS1}
                  onChange={handleChange}
                  error={Boolean(errors.COMPADDRESS1)}
                  helperText={errors.COMPADDRESS1}
                />
              </Grid>

              <Grid item xs={12} md={6} sm={12} lg={6} xl={6}>
                <TextField
                  id="com_txt6"
                  name="HOTLINE"
                  label="Hotline"
                  fullWidth
                  size="small"
                  variant="standard"
                  autoComplete="off"
                  value={companyData?.HOTLINE || ""}
                  // value={companyData.HOTLINE}
                  onChange={handlenumInputValidation}
                  error={!!errors.HOTLINE}
                  helperText={errors.HOTLINE}
                />
              </Grid>
              <Grid item xs={12} md={6} sm={12} lg={6} xl={6}>
                <TextField
                  id="com_txt3"
                  name="COMPADDRESS2"
                  label="Address 2"
                  fullWidth
                  size="small"
                  variant="standard"
                  autoComplete="off"
                  value={companyData?.COMPADDRESS2 || ""}
                  // value={companyData.COMPADDRESS2}
                  onChange={handleChange}
                  error={Boolean(errors.COMPADDRESS2)}
                  helperText={errors.COMPADDRESS2}
                />
              </Grid>
              <Grid item xs={12} md={6} sm={12} lg={6} xl={6}>
                <TextField
                  id="com_txt7"
                  name="FAX"
                  label="Fax"
                  fullWidth
                  size="small"
                  variant="standard"
                  autoComplete="off"
                  // value={companyData.FAX}
                  value={companyData?.FAX || ""}
                  onChange={handlenumInputValidation}
                  error={!!errors.FAX}
                  helperText={errors.FAX}
                />
              </Grid>
              <Grid item xs={12} md={6} sm={12} lg={6} xl={6}>
                <TextField
                  id="com_txt4"
                  name="COMPADDRESS3"
                  label="Address 3"
                  fullWidth
                  size="small"
                  variant="standard"
                  autoComplete="off"
                  // value={companyData.COMPADDRESS3}
                  value={companyData?.COMPADDRESS3 || ""}
                  onChange={handleChange}
                  error={Boolean(errors.COMPADDRESS3)}
                  helperText={errors.COMPADDRESS3}
                />
              </Grid>
              <Grid item xs={12} md={6} sm={12} lg={6} xl={6}>
                <TextField
                  id="com_txt8"
                  name="EMAIL"
                  label="Email Address"
                  size="small"
                  fullWidth
                  variant="standard"
                  autoComplete="off"
                  // value={companyData.EMAIL}
                  value={companyData?.EMAIL || ""}
                  onChange={handleEmailValidation}
                  error={!!errors.EMAIL}
                  helperText={errors.EMAIL}
                  disabled
                />
              </Grid>

              <Grid item xs={12} md={6} sm={12} lg={6} xl={6}>
                <TextField
                  id="com_txt9"
                  name="CONTATCPERSON"
                  label="Contact Person"
                  size="small"
                  fullWidth
                  variant="standard"
                  autoComplete="off"
                  // value={companyData.CONTATCPERSON}
                  value={companyData?.CONTATCPERSON || ""}
                  onChange={handleChange}
                  error={Boolean(errors.CONTATCPERSON)}
                  helperText={errors.CONTATCPERSON}
                />
              </Grid>

              <Grid item lg={6} md={6} xs={12} sm={12}>
                <Autocomplete
                  value={
                    companyData?.COUNTRYCODE
                      ? (Array.isArray(data2) &&
                          data2.find(
                            (item) =>
                              item.COUNTRYCODE === companyData?.COUNTRYCODE
                          )) ||
                        null
                      : null
                  }
                  options={data2 || []} // Ensure that options are an empty array if data2 is null or undefined
                  getOptionLabel={(option) => option.COUNTRY || ""} // Show country name in the dropdown
                  onChange={handleCountryChange} // Handle change and set COUNTRYCODE when an option is selected
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Country"
                      variant="standard"
                      size="small"
                      fullWidth
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper, // Apply theme background
                    },
                  }}
                />
              </Grid>
              <Box
                width={"100%"}
                direction="row"
                spacing={2}
                display={"flex"}
                justifyContent="flex-end"
                gap={2}
                sx={{
                  mt: 2,
                  background: theme.palette.background.paper,
                }}
              >
                <Button
                  id="com_btn_cl"
                  variant="outlined"
                  sx={styles.AI_button1}
                  onClick={handleClear}
                >
                  Clear
                </Button>
                <Button
                  id="com_btn_mod"
                  variant="contained"
                  sx={styles.AI_button2}
                  onClick={handleSubmit}
                >
                  Modify
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Snackbar
        id="com_snack1"
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ top: "10%", right: "10%" }}
      >
        <Alert
          id="com_al1"
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          Updated Successfully!
        </Alert>
      </Snackbar>

      {/* Snackbar for Error */}
      <Snackbar
        id="com_snack2"
        open={openErrorSnackbar}
        autoHideDuration={6000}
        onClose={handleErrorSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ top: "10%", right: "10%" }}
      >
        <Alert
          id="com_al2"
          onClose={handleErrorSnackbarClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Managecompany;
